"use strict";


let __SWNS = {};
(($, win, doc)=> {    // JQ ES6 sw Pack

  let $win = $(win),
      $doc = $(doc),
      $html = $('html'),
      $body = $('body'),
      swns = {
        theDate() {
          let today = new Date();
          let day = ["Sun", "Mon", "Tue", "Wed", "Thu", "Fri", "Sat"];
          let y = today.getFullYear();
          let m = today.getMonth() + 1;
          let d = today.getDate();
          let w = today.getDay();
          let H = today.getHours();
          let M = today.getMinutes();
          let S = today.getSeconds();
          if (m < 10) { m = "0" + m; }
          if (d < 10) { d = "0" + d; }
          if (H < 10) { H = "0" + H; }
          if (M < 10) { M = "0" + M; }
          if (S < 10) { S = "0" + S; }
          return `${day[w]}:` + m + "/" + d + "/" + H + ":" + M + "." + S;
        },
        goToTop: function() {
          let $goToTop = $("#goto-top");
          $goToTop.hide();
          $.timeout = function(time) {
            return $.Deferred(function(dfd) {
              return setTimeout(dfd.resolve, time);
            }).promise();
          };
          $win.on("scroll", function() {
            if ($(this).scrollTop() > 555) {
              $goToTop.stop(true, true).fadeIn();
            } else {
              $goToTop.fadeOut();
            }
          });
          $goToTop.on("click", function(e) {
            e.preventDefault();
            $("body,html").animate({ scrollTop: 0 }, 200);
          });
        },
        getUrlVars() {
          let vars = [];
          let max = 0;
          let hash = '';
          let array = '';
          let url = window.location.search;
          hash = url.slice(1).split('&');
          max = hash.length;
          let i = 0;
          while (i < max) {
            array = hash[i].split('=');
            /*fixup 日本語にデコードUTF8
            *  ※ すべての文字がエンコードされるので、/tatsuya/js/index.htm などのパスを表す文字列には注意が必要です。
              ※ スラッシュ (/) もエンコードされるので、Web サーバーへの要求として送信する場合は無効になります。
              ※ 文字列に URI コンポーネントが複数含まれる場合は、encodeURI 関数を使用します。
              */
            //vars.push(array[0]);
            vars.push( decodeURIComponent(array[0]) );
            //vars[array[0]] = array[1];
            vars[array[0]] = decodeURIComponent(array[1]);
            i++;
          }
          return vars;
        }
      }; // swns{}

  /* animateCallback
  * # fixme 未使用だからはずす
  */

  /* 画像プリローダーAssy */
  let preloader = (images)=> {
    $(images).each(function() { (new Image()).src = this; });
  };
  $(()=> { preloader([
    "/special/global/images/favicon.png",
    "/special/global/images/logos_1.png",
    "/special/global/images/logos_2.svg",
    "/special/global/images/logos_3.svg"
    ]);
  });


  /* plugin Type BlockLink */
  $.fn.blocklinkAssy = function() { // bind under this
    $(this).on("click", function(e) {
      e.preventDefault();
      win.open($(this).find("a").attr("href"), $(this).find("a").attr("target") || "_self");
    }).css({ cursor: "pointer" });
  };

  let attrLangTitle = ()=> {
    if ($html.hasClass("yokado-ja")) {
      $("div.nice-select span.current").text("日本語");
      $("#displayLang").attr("data-display", "日本語").text("日本語")
    }
    if ($html.hasClass("yokado-en")) {
      $("div.nice-select span.current").text("English");
      $("#displayLang").attr("data-display", "English").text("日本語")
    }
    if ($html.hasClass("yokado-tw")) {
      $("div.nice-select span.current").text("繁体中文");
      $("#displayLang").attr("data-display", "繁体中文").text("日本語")
    }
    if ($html.hasClass("yokado-cn")) {
      $("div.nice-select span.current").text("简体中文");
      $("#displayLang").attr("data-display", "简体中文").text("日本語")
    }
    if ($html.hasClass("yokado-kr")) {
      $("div.nice-select span.current").text("한국어");
      $("#displayLang").attr("data-display", "한국어").text("日本語")
    }
  };

  let navCurrentAdd = ()=> {
    let filename = $(".current-control").attr("id");
    //let url = win.location.href.split("/");
    //url = url[url.length -1].split(".html")[0];
    $("#SideNavBase").find("li").each(function(i, val) {
      $(this).removeClass("current");
      let nav_id = $(this).attr("id");
      if (nav_id === filename) { $(this).addClass("current"); }
    })
  };


  // do it DRF
  $(()=> {
    /*トップに戻る Assy */
    swns.goToTop();

    /*UI / UA */
    $("#wrapper").find("h2,h3").each(function() {
      return $(this).wrapInner("<span class='add-span' />");
    });

    /* BlockLink Assy */
    $(".hNavi").blocklinkAssy();

    // add current class for nav
    navCurrentAdd();

    /* SideNav */
    $("#SideNavBase > li").clone().appendTo("#SideNavClone ul");

    // attr LangMenu to Nice before INIT
    attrLangTitle();
    // fixup Back Forward Cache
    $(win).on('pageshow', function (e) {
      //console.info(e.type);  // #------- sw Log --(´･_･`)
      attrLangTitle();
    });

    let niceFunction =(selector)=> {
      $(selector).niceSelect();
      $(selector).on("change", function (e) {
        let val = $(this).val();
        if (val) {
          return win.open(val, "_self");
        }
      })
    };
    niceFunction("select.nice");


    /**
     * swAnchor アンカー残し版（/#hoge） no return false;
     * @ fixup 外部リンクを避ける修正 & if(target.length) {}
     */
    $('a.swAnchor').click(function (e) {
      //e.preventDefault();
      let speed = 543;
      let href = $(this).attr("href");
      if (href.indexOf("#") === 0) {
        let target = $(href === "#" || href === "" ? 'html' : href);
        if (target.length) {
          let position = target.offset().top;
          $("html, body").animate({scrollTop: position - 30}, speed, "easeOutCirc");
          //return false;
        }
      }
    });

    /**
     *  id="swSlide" .slideUrl
     *  sw <!--lang/class各言語に設定[ja/en/tw/cn/kr]-->
     */
    if ($("body#top").length) {
      $("#swSlide a.slideUrl").each(function () {
        let href = $(this).attr("href");
        if ($(".yokado-tw").length) {
          href = href.replace(/\/en\//g,'/tw/');
          $(this).attr("href", href);
        } else if ($(".yokado-cn").length) {
          href = href.replace(/\/en\//g,'/cn/');
          $(this).attr("href", href);
        } else if ($(".yokado-kr").length) {
          href = href.replace(/\/en\//g,'/kr/');
          $(this).attr("href", href);
        } else {
          $(this).attr("href", href);
        }
      });
      $("#swSlide img.slideTxt").each(function () {
        let src = $(this).attr("src");
        if ($(".yokado-tw").length) {
          src = src.replace(/-en\./g,'-tw.');
          $(this).attr("src", src);
        } else if ($(".yokado-cn").length) {
          src = src.replace(/-en\./g,'-cn.');
          $(this).attr("src", src);
        } else if ($(".yokado-kr").length) {
          src = src.replace(/-en\./g,'-kr.');
          $(this).attr("src", src);
        } else {
          $(this).attr("src", src);
        }
      });

      /*$("g#layer2 a").each(function () {
        let href = $(this).attr("xlink:href");
        if ($(".yokado-tw").length) {
          href = href.replace(/\/en\//g,'/tw/');
          $(this).attr("xlink:href", href);
        } else if ($(".yokado-cn").length) {
          href = href.replace(/\/en\//g,'/cn/');
          $(this).attr("xlink:href", href);
        } else if ($(".yokado-kr").length) {
          href = href.replace(/\/en\//g,'/kr/');
          $(this).attr("xlink:href", href);
        } else {
          $(this).attr("xlink:href", href);
        }
      });*/
    }

    /**
     *  id="shops" .hasSvg svgMap
     *  sw <!--lang/class各言語に設定[ja/en/tw/cn/kr]-->
     */
    /*if ($("#wrapper #shops.hasSvg").length) {
      $("g#layer2 a, g#layer3 a").each(function () {
        let href = $(this).attr("xlink:href");
        if ($(".yokado-tw").length) {
          href = href.replace(/\/en\//g,'/tw/');
          $(this).attr("xlink:href", href);
        } else if ($(".yokado-cn").length) {
          href = href.replace(/\/en\//g,'/cn/');
          $(this).attr("xlink:href", href);
        } else if ($(".yokado-kr").length) {
          href = href.replace(/\/en\//g,'/kr/');
          $(this).attr("xlink:href", href);
        } else {
          $(this).attr("xlink:href", href);
        }
      });
    }*/

  }); // DRF }
})(jQuery, window, document);
